<template>
  <FilledLoader />
</template>

<script>
import FilledLoader from '@/decast/components/common/FilledLoader.vue';


export default {
  data() {
    return {
    };
  },
  components: {
  },
  mounted() {
    document.getElementById('loading-bg').style.display = 'block';
    this.verifyDidJwt();
  },
  methods: {
    verifyDidJwt() {
      const payload = {
        didJwt: this.$route.query.didJwt,
        audience: this.$route.query.audience,
      };
      this.$store
        .dispatch('auth/v2verifyDidJwt', payload)
        .then((response) => {
          const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
          if (isTwoFactorAuthEnabled) {
            //ask for 2fa
            const twoFactorToken = response.data?.token;
            this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
          } else {
            this.$store.commit('auth/SET_LOGGEDIN', true);
            this.$acl.change('user');
            this.$vs.notify({
              title: 'Login Successful',
              text: 'Redirecting to dashboard!',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success',
            });
            this.$router.push('/dashboard/rooms');
          }
        })
        .catch((error) => {
          // Safely extract the specific error message
          const errorResponse = error.response?.data;
          let message = "An error occurred.";
          if (errorResponse?.errors?.email) {
            message = "Account does not exist!";
          } else if (errorResponse?.errors?.password) {
            message = errorResponse?.errors?.password;
          } else if (typeof errorResponse?.errors === 'string') {
            message = errorResponse.errors;
          }
          this.$vs.notify({
            title: 'Session Expired!',
            text: "Failed to verify did Jwt",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
          this.$router.push('/');
        }).finally(() => {
          document.getElementById('loading-bg').style.display = 'none';
        });
    },
  }
}
</script>

<style scoped>
*:not(i) {
  /* font-family: 'Karla', sans-serif !important; */
  font-family: 'Rethink Sans' !important;
}
</style>
